(function () {
  "use strict";

  // PREVENT LOOPS: Tracking set to ensure we don't process the same element twice
  const processed = new WeakSet();

  /* ============================================================
     Helpers & Ignore List
  ============================================================ */
  function isRoot(el) {
    return el === document.documentElement || el === document.body;
  }

  function isIgnored(el) {
    if (!el) return false;
    // Explicitly ignore Shopify's tracking sandboxes and admin bar
    if (el.id && (el.id.includes("web-pixels-manager") || el.id.includes("admin-bar") || el.id.includes("ShopifyAnalytics"))) return true;
    if (el.closest && el.closest("#web-pixels-manager-sandbox-container, #admin-bar-iframe")) return true;
    return false;
  }

  function setOrig(el, key, val) {
    var attr = "data-a11y-orig-" + key;
    if (!el.hasAttribute(attr)) el.setAttribute(attr, val === null ? "" : String(val));
  }

  function getOrig(el, key) {
    return el.getAttribute("data-a11y-orig-" + key);
  }

  function clearOrig(el, key) {
    el.removeAttribute("data-a11y-orig-" + key);
  }

  function restoreAttr(el, key, realAttr) {
    var prev = getOrig(el, key);
    if (prev === null) return;
    if (prev === "") el.removeAttribute(realAttr);
    else el.setAttribute(realAttr, prev);
    clearOrig(el, key);
  }

  function debounce(fn, delay) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    };
  }

  /* ============================================================
     1) Core Locking Logic (Updated with Loop Protection)
  ============================================================ */
  function lockElement(el) {
    if (!el || !el.tagName || isIgnored(el) || processed.has(el)) return;
    var tag = el.tagName.toLowerCase();

    if (el.hasAttribute("tabindex")) {
      setOrig(el, "tabindex", el.getAttribute("tabindex"));
      el.removeAttribute("tabindex");
    }

    if (tag === "a" && el.hasAttribute("href")) {
      setOrig(el, "href", el.getAttribute("href"));
      el.removeAttribute("href");
      el.setAttribute("aria-disabled", "true");
    }

    if (tag === "button" || tag === "input" || tag === "select" || tag === "textarea") {
      if (!el.hasAttribute("data-a11y-orig-disabled")) {
        el.setAttribute("data-a11y-orig-disabled", el.disabled ? "1" : "0");
      }
      el.disabled = true;
    }

    if (tag === "iframe") {
      el.setAttribute("inert", "");
      el.setAttribute("tabindex", "-1");
    }

    processed.add(el);
  }

  function unlockElement(el) {
    if (!el || !el.tagName || isIgnored(el)) return;
    var tag = el.tagName.toLowerCase();

    restoreAttr(el, "tabindex", "tabindex");

    if (tag === "a" && el.hasAttribute("data-a11y-orig-href")) {
      var href = getOrig(el, "href");
      if (href && href !== "") el.setAttribute("href", href);
      clearOrig(el, "href");
      el.removeAttribute("aria-disabled");
    }

    if (el.hasAttribute("data-a11y-orig-disabled")) {
      var wasDisabled = el.getAttribute("data-a11y-orig-disabled") === "1";
      el.disabled = wasDisabled;
      el.removeAttribute("data-a11y-orig-disabled");
    }

    if (tag === "iframe") {
      el.removeAttribute("inert");
    }
    
    processed.delete(el);
  }

  function syncHiddenContainer(container) {
    if (!container || !container.getAttribute || isRoot(container) || isIgnored(container)) return;

    var hidden = container.getAttribute("aria-hidden") === "true";

    if (hidden) {
      container.setAttribute("inert", "");
      lockElement(container);
      var nodes = container.querySelectorAll(
        "a[href],button,input,select,textarea,iframe,[tabindex],[contenteditable='true']"
      );
      for (var i = 0; i < nodes.length; i++) lockElement(nodes[i]);
    } else {
      container.removeAttribute("inert");
      unlockElement(container);
      var nodes2 = container.querySelectorAll(
        "a,button,input,select,textarea,iframe,[data-a11y-orig-tabindex],[data-a11y-orig-href],[data-a11y-orig-disabled]"
      );
      for (var j = 0; j < nodes2.length; j++) unlockElement(nodes2[j]);
    }
  }

  /* ============================================================
     2) Shopify-Specific & Clean-up Logic
  ============================================================ */
  function patchAllAriaHidden() {
    // Specifically target the Web Pixels offender first
    const pixelContainer = document.getElementById('web-pixels-manager-sandbox-container');
    if (pixelContainer) syncHiddenContainer(pixelContainer);

    document.querySelectorAll("[aria-hidden='true']").forEach(function(el) {
      if (!isIgnored(el)) syncHiddenContainer(el);
    });
  }

  function patchSlickGlobal(root) {
    var scope = root || document;
    scope.querySelectorAll('.slick-track[role="listbox"]').forEach(el => el.removeAttribute("role"));
    scope.querySelectorAll(".slick-dots li button").forEach((btn, idx) => {
      if (!btn.getAttribute("aria-label")) btn.setAttribute("aria-label", "Go to slide " + (idx + 1));
      btn.setAttribute("tabindex", btn.parentElement.classList.contains("slick-active") ? "0" : "-1");
    });
  }

  function addMissingNames(root) {
    var scope = root || document;
    scope.querySelectorAll("button, a").forEach(function (el) {
      if (isIgnored(el)) return;
      var hasName = el.getAttribute("aria-label") || el.getAttribute("aria-labelledby") || (el.textContent && el.textContent.trim().length > 0);
      if (hasName) return;

      if (el.tagName.toLowerCase() === 'button') {
        var cls = (el.className || "").toLowerCase();
        if (cls.includes("search")) el.setAttribute("aria-label", "Search");
        else if (cls.includes("close") || cls.includes("modal")) el.setAttribute("aria-label", "Close");
        else el.setAttribute("aria-label", "Button");
      } else {
        el.setAttribute("aria-label", "Link");
      }
    });
  }

  /* ============================================================
     Execution
  ============================================================ */
  var inPatch = false;
  function runAllPatches() {
    if (inPatch) return;
    inPatch = true;
    try {
      patchAllAriaHidden();
      patchSlickGlobal(document);
      addMissingNames(document);
    } catch (e) {} 
    finally { inPatch = false; }
  }

  var scheduleRunAll = debounce(runAllPatches, 250);

  document.addEventListener("DOMContentLoaded", runAllPatches);
  window.addEventListener("load", runAllPatches);
  setTimeout(runAllPatches, 1500); // Late catch for Shopify pixels

  new MutationObserver(function (mutations) {
    if (inPatch) return;
    let needsRun = false;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length || mutations[i].attributeName === "aria-hidden") {
        needsRun = true;
        break;
      }
    }
    if (needsRun) scheduleRunAll();
  }).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["aria-hidden"]
  });

  if (window.jQuery) {
    window.jQuery(function ($) {
      $(document).on("init reInit afterChange", ".slick-slider", () => scheduleRunAll());
    });
  }
})();
